import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JobInfoComponent } from './components/job-info/job-info.component';
import { JobDescriptionComponent } from './components/job-description/job-description.component';
import { RouterModule } from '@angular/router';
import { SharedComponentsModule } from '../shared/modules/shared-components/shared-components.module';
import { CommonAppModuleModule } from '../common-app-module/common-app-module.module';

@NgModule({
  declarations: [JobInfoComponent, JobDescriptionComponent],
  imports: [
    CommonModule,
    RouterModule,
    SharedComponentsModule,
    CommonAppModuleModule
  ],
  exports: [JobInfoComponent, JobDescriptionComponent]
})
export class JobsSharedModule { }
